import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/views/home'
import Service from '@/views/service'
import Technology from '@/views/technology'
import AboutUs from '@/views/about_us'
import Contact from '@/views/contact'

Vue.use(Router)


export default new Router({
  mode:"history",
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/technology',
      name: 'Technology',
      component: Technology
    },
    {
      path: '/about',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }
  ]
})
// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'Layout',
//       component: Layout,
//       children:[
//         {
//           path: '/',
//           component:HelloWorld
//         },
//       ]
//     }
//   ]
// })



// WEBPACK FOOTER //
// ./src/router/index.js